<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<div class="sakai-table-container">
	<ng-container *ngIf="loading">
		<p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
		<div class="p-text-center p-mt-3">{{ classMode === 0 ? translateServ.dictionary['LOADING_FILES'] :
			translateServ.dictionary['LOADING_HISTORY'] }}...</div>
	</ng-container>

	<ng-container *ngIf="!loading && errorMessage">
		<div class="flex flex-column align-items-center justify-content-center h-20rem p-5">
			<div class="p-message p-message-error p-message-icon text-center"
				style="margin-bottom: 1rem; padding: 2rem; border-radius: var(--border-radius); width: 100%;">
				<i class="pi pi-times-circle text-6xl mb-3"></i>
				<div class="font-bold text-xl mb-3">{{ errorMessage }}</div>
				<button pButton type="button" icon="pi pi-refresh" label="{{ translateServ.dictionary['RETRY']}}"
					(click)="initData(true)" class="p-button-raised p-button-danger"></button>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!loading && !errorMessage">
		<div class="card">
			<div class="font-semibold text-xl mb-4">
				{{ classMode === 0 ? translateServ.dictionary['DOC_APP_TITLE'] :
				translateServ.dictionary['ITEM_DOC_HIST'] }}
			</div>
			<p-tabView *ngIf="fileClassifications.length > 0" [(activeIndex)]="activeClassificationIndex"
				(onChange)="onClassificationTabChange($event)">
				<p-tabPanel *ngFor="let classification of fileClassifications; let classificationIndex = index">
					<ng-template pTemplate="header">
						<span class="flex align-items-center gap-2">
							<i *ngIf="classification.IconGrade" [class]="classification.IconGrade || ''"></i>
							<span>{{ classification.FileGradeClassification }}</span>
						</span>
					</ng-template>
					<ng-container *ngIf="classificationIndex === activeClassificationIndex">
						<div class="main-table-container">
							<p-table id="tab_doc_watch" #dt
								styleClass="app-data-table app-data-table--paged doc-approval-table"
								[style]="{'width': '100%'}" [value]="allDocuments" dataKey="FileRecID"
								stateStorage="session" [stateKey]="docApprovalStateKey" paginator="true"
								[totalRecords]="allDocuments.length" [rows]="getCurrentPageSize(0, allDocuments.length)"
								[responsiveLayout]="'scroll'" [rowsPerPageOptions]="setPaginator(allDocuments.length)"
								[rowExpandMode]="'single'" [paginatorDropdownAppendTo]="'body'"
								[globalFilterFields]="['FileRecID', 'FileCategory', 'DocNumber', 'FilePublishDate', 'CustomerName', 'Business_ID', 'total_with_tax', 'tax', 'vat_in_precentages', 'allocation_number', 'CustomerSupplierExpenseCode', 'Sug_tnua']"
								[filterDelay]="0" [sortMode]="'single'"
								[rowGroupMode]="'subheader'"
								[groupRowsBy]="classMode === 1 ? 'DateEnteredMonthYear' : 'DateEnteredDay'"
								[sortField]="classMode === 1 ? 'DateEnteredGroupSort' : 'DateEnteredDaySort'" [sortOrder]="-1"
								[(selection)]="selectedDocuments" [selectionMode]="'multiple'"
								(onSort)="onTableSortOrFilter($event)" (onFilter)="onTableSortOrFilter($event)"
								(selectionChange)="onSelectionChange($event)"
								(onPage)="onRowsPerPageChange($event, 0, allDocuments.length)">
								<ng-template pTemplate="caption">
									<div class="flex align-items-center justify-content-between">
										<button *ngIf="classMode === 0 && activeClassificationIndex === 1 && journalLessDocuments.length > 0"
											pButton type="button" icon="pi pi-exclamation-triangle"
											class="p-button-sm p-button-warning p-button-icon-only journal-less-indicator"
											[ngClass]="{'journal-less-indicator--flashing': hasJournalLessSelection}"
											pTooltip="{{ translateServ.dictionary['ORPHAN_FILE_FOUND']}}"
											tooltipPosition="bottom"
											(click)="openJournalLessDialog()"></button>
										<div class="flex align-items-center gap-2"
											[ngClass]="(directionServ.currentDirection$ | async) === 'ltr' ? 'ml-auto' : 'mr-auto'">

											<button *ngIf="classMode === 0" pButton type="button"
												label="{{ translateServ.dictionary['WORKBENCH_MERGE'] }}"
												icon="pi pi-box" class="p-button-sm p-button-outlined"
												(click)="openWorkbenchDialog()"></button>
										<div *ngIf="classMode === 0" class="bulk-move-btn-group">
											<button pButton type="button" icon="pi pi-truck"
												class="p-button-sm"
												[ngClass]="bulkMoveModeActive && bulkMoveFileRecIds.length > 0 ? '' : 'p-button-outlined'"
												[label]="!bulkMoveModeActive ? (translateServ.dictionary['SELECT_FILES_TO_MOVE'] || 'Select Files to Move') : (bulkMoveFileRecIds.length > 0 ? (translateServ.dictionary['SHIP_FILES'] || 'Ship') + ' (' + bulkMoveFileRecIds.length + ')' : bulkMoveFileRecIds.length + ' ' + (translateServ.dictionary['SELECTED'] || 'selected'))"
												[pTooltip]="bulkMoveModeActive && bulkMoveFileRecIds.length === 0 ? (translateServ.dictionary['DBLCLICK_SELECT_ALL'] || 'Double-click to select all visible files') : ''"
												tooltipPosition="bottom"
												(dblclick)="onBulkMoveMainButtonDblClick(dt)"
												(click)="onBulkMoveMainButtonClick($event, bulkShipPanel)"></button>
											<button *ngIf="bulkMoveModeActive" pButton type="button" icon="pi pi-times"
												class="p-button-sm p-button-outlined"
												pTooltip="{{ translateServ.dictionary['CANCEL'] || 'Cancel' }}" tooltipPosition="bottom"
												(click)="cancelBulkMove()"></button>
										</div>
										<p-overlayPanel #bulkShipPanel [appendTo]="'body'">
											<div class="flex flex-column gap-2" style="min-width: 12rem;">
												<button *ngFor="let option of getReassignClassificationOptions()"
													pButton type="button"
													class="p-button-text p-button-sm justify-content-start"
													(click)="shipBulkMove(option, bulkShipPanel)">
													<span class="flex align-items-center gap-2">
														<i *ngIf="option.IconGrade" [class]="option.IconGrade || ''"></i>
														<span>{{ option.FileGradeClassification }}</span>
													</span>
												</button>
											</div>
										</p-overlayPanel>
											<button pButton type="button" icon="pi pi-filter-slash"
												label="{{ translateServ.dictionary['BTN_REMOVE_ALL_FILTERS']}}"
												[ngClass]="hasActiveTableFilters ? 'p-button-sm' : 'p-button-sm p-button-outlined'"
												(click)="clearAllFilters(dt, globalSearchInput)"></button>

										<p-splitButton *ngIf="isExportButtonVisible() && classMode === 0 && activeClassificationIndex === 1"
											[label]="getExportButtonLabel()" icon="pi pi-download"
											styleClass="p-button-sm p-button-outlined" [style]="{'width': 'auto'}"
											[model]="exportActions" (onClick)="onExportButtonClick(0)">
										</p-splitButton>
										<button *ngIf="isExportButtonVisible() && !(classMode === 0 && activeClassificationIndex === 1)"
												pButton type="button" icon="pi pi-download"
												class="p-button-sm p-button-outlined"
												[label]="getExportButtonLabel()"
												(click)="onExportButtonClick(0)"></button>
											<button pButton type="button" icon="pi pi-tag"
												class="p-button-sm p-button-outlined"
												label="{{ translateServ.dictionary['GO_TO_LAST_VIEWED'] || 'Go to Last Viewed' }}"
												(click)="goToLastViewed(dt)">
											</button>

											<span class="p-input-icon-left ml-4">
												<i class="pi pi-search"></i>
												<input #globalSearchInput pInputText type="text" class="p-inputtext-sm"
													(input)="dt.filterGlobal($any($event.target).value, 'contains')"
													placeholder="{{ translateServ.dictionary['SEARCH']}}..." />
											</span>
										</div>
									</div>
								</ng-template>
								<ng-template pTemplate="header">
									<tr>
										<th style="width: 3rem;">
											<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
										</th>

										<th style="width: 3rem;"></th>

										<th style="width: 6rem; text-align: center;" [pSortableColumn]="'NotifCount'">
											<div class="flex align-items-center justify-content-center">
												<i class="pi pi-bell"></i>
												<p-sortIcon field="NotifCount"></p-sortIcon>
											</div>
										</th>

									<th pSortableColumn="FileRecID" style="min-width: 100px;">
										<div class="flex align-items-center gap-2 flex-nowrap app-header-flex">
											<span class="split-filter-label">{{ translateServ.dictionary['JMT_COL_ID']}}</span>
											<p-sortIcon field="FileRecID"></p-sortIcon>
											<p-columnFilter type="numeric" field="FileRecID"
												display="menu"></p-columnFilter>
										</div>
										</th>
										<th [pSortableColumn]="categorySortField" style="min-width: 120px;">
										<div class="flex align-items-center gap-2 flex-nowrap app-header-flex split-filter-header">
												<span class="split-filter-label">{{ translateServ.dictionary['FF_DOC']}}</span>
												<p-sortIcon [field]="categorySortField"></p-sortIcon>
												<p-columnFilter type="text" [field]="categorySortField"
													display="menu">
													<ng-template pTemplate="header">
														<div class="flex flex-column gap-2 p-2"
															(click)="$event.stopPropagation()">
														<i class="pi pi-filter font-semibold text-sm"></i>
															<p-dropdown [options]="categoryFieldOptions"
																[(ngModel)]="categorySortField" optionLabel="label"
																optionValue="value" styleClass="p-inputtext-sm"
																[style]="{'width': '100%'}" appendTo="body"
																(onChange)="ensureFilterConstraint(dt, categorySortField, 'text')"></p-dropdown>
														</div>
													</ng-template>
												</p-columnFilter>
											</div>
										</th>
									<th pSortableColumn="FilePublishDate" style="min-width: 120px;">
										<div class="flex align-items-center gap-2 flex-nowrap app-header-flex">
											<span class="split-filter-label">{{ translateServ.dictionary['doc_publish_date']}}</span>
											<p-sortIcon field="FilePublishDate"></p-sortIcon>
											<p-columnFilter type="text" field="FilePublishDate"
												display="menu"></p-columnFilter>
										</div>
										</th>
									<th [pSortableColumn]="supplierSortField" style="min-width: 140px;">
									<div class="flex align-items-center gap-2 flex-nowrap app-header-flex split-filter-header">
											<span class="split-filter-label">{{ translateServ.dictionary['SUPPLIER']}}</span>
											<p-sortIcon [field]="supplierSortField"></p-sortIcon>
											<p-columnFilter type="text" [field]="supplierSortField"
												display="menu">
												<ng-template pTemplate="header">
													<div class="flex flex-column gap-2 p-2"
														(click)="$event.stopPropagation()">
													<i class="pi pi-filter font-semibold text-sm"></i>
														<p-dropdown [options]="supplierFieldOptions"
															[(ngModel)]="supplierSortField" optionLabel="label"
															optionValue="value" styleClass="p-inputtext-sm"
															[style]="{'width': '100%'}" appendTo="body"
															(onChange)="ensureFilterConstraint(dt, supplierSortField, 'text')"></p-dropdown>
													</div>
												</ng-template>
											</p-columnFilter>
										</div>
										</th>
									<th pSortableColumn="allocation_number" style="min-width: 120px;">
										<div class="flex align-items-center gap-2 flex-nowrap app-header-flex">
											<span class="split-filter-label">{{ translateServ.dictionary['JMT_COL_ALLOC_NUMBER']}}</span>
											<p-sortIcon field="allocation_number"></p-sortIcon>
											<p-columnFilter type="text" field="allocation_number"
												display="menu"></p-columnFilter>
										</div>
										</th>
										<th [pSortableColumn]="totalsSummarySortField" style="min-width: 160px;">
										<div class="flex align-items-center gap-2 flex-nowrap app-header-flex split-filter-header">
												<span class="split-filter-label">{{ translateServ.dictionary['TOTALS_SUMMARY']}}</span>
												<p-sortIcon [field]="totalsSummarySortField"></p-sortIcon>
												<p-columnFilter type="numeric" [field]="totalsSummarySortField"
													display="menu">
													<ng-template pTemplate="header">
														<div class="flex flex-column gap-2 p-2"
															(click)="$event.stopPropagation()">
															<i class="pi pi-filter font-semibold text-sm"></i>
															<p-dropdown [options]="totalsSummaryFieldOptions"
																[(ngModel)]="totalsSummarySortField"
																optionLabel="label" optionValue="value"
																styleClass="p-inputtext-sm" [style]="{'width': '100%'}"
																appendTo="body"
																(onChange)="ensureFilterConstraint(dt, totalsSummarySortField, 'numeric')"></p-dropdown>
														</div>
													</ng-template>
												</p-columnFilter>
											</div>
										</th>

										<th [pSortableColumn]="expenseSortField" style="min-width: 120px;">
										<div class="flex align-items-center gap-2 flex-nowrap app-header-flex split-filter-header">
												<span class="split-filter-label">{{ translateServ.dictionary['EXPENSES_DATA']}}</span>
												<p-sortIcon [field]="expenseSortField"></p-sortIcon>
												<p-columnFilter type="text" [field]="expenseSortField"
													display="menu">
													<ng-template pTemplate="header">
														<div class="flex flex-column gap-2 p-2"
															(click)="$event.stopPropagation()">
															<i class="pi pi-filter font-semibold text-sm"></i>
															<p-dropdown [options]="expenseFieldOptions"
																[(ngModel)]="expenseSortField" optionLabel="label"
																optionValue="value" styleClass="p-inputtext-sm"
																[style]="{'width': '100%'}" appendTo="body"
																(onChange)="ensureFilterConstraint(dt, expenseSortField, 'text')"></p-dropdown>
														</div>
													</ng-template>
												</p-columnFilter>
											</div>
										</th>
										<th style="min-width: 100px;">{{ translateServ.dictionary['STEP_TAB_TIT_ACT']}}
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="groupheader" let-row>
									<tr class="date-group-row">
										<td colspan="11" class="date-group-cell">
											{{ classMode === 1 ? row.DateEnteredMonthYear : row.DateEnteredDay }}
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-row>
									<tr (dblclick)="openPreview(row.FileRecID)"
										[ngClass]="{'lastly-viewed-row': isLastlyViewed(row), 'bulk-move-marked-row': bulkMoveFileRecIds.includes(row.FileRecID)}">
										<td>
											<p-tableCheckbox [value]="row" (change)="onDocumentCheckboxChange($event, row)"></p-tableCheckbox>
										</td>
										<td>
											<button type="button" class="p-button p-button-text p-button-sm p-button-rounded" (click)="toggleRowExpanded(row)">
												<i class="pi" [ngClass]="row.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
											</button>
										</td>
										<td style="width: 5rem; text-align: center;">
											<p-tag [icon]="'pi pi-bell'" [value]="getNotificationTag(row).value"
												[severity]="getNotificationTag(row).severity" [rounded]="true"
												[pTooltip]="getNotificationTag(row).tooltip"
												(click)="openNotificationsDialog(row)" [style]="{'cursor': 'pointer'}">
											</p-tag>
										</td>
										<td>
											<span pTooltip="{{ row.OriginalFileName }}" tooltipPosition="top">{{
												row.FileRecID
												}}</span>
										</td>
										<td style="padding: 0 4px;">
											<span [pTooltip]="row.FileCategory" tooltipPosition="top" style="line-height: 1.1;">
												{{ row.DocNumber }}<br />
												<span style="font-size: 0.95em; color: #666;">{{ row.FileCategory }}</span>
											</span>
										</td>
									<td>{{ row.FilePublishDate }}</td>
										<td style="padding: 0 4px;">
											<span [pTooltip]="row.Business_ID" tooltipPosition="top" style="line-height: 1.1;">
												{{ row.CustomerName }}<br />
												<span style="font-size: 0.95em; color: #666;">{{ row.Business_ID }}</span>
											</span>
										</td>

										<td>
											<ng-container *ngIf="row.allocation_number">
												<span pTooltip="{{ row.allocation_number }}" tooltipPosition="top">
													{{ row.allocation_number?.slice(-9) }}
												</span>
											</ng-container>
										</td>
										<td>
											<div><strong>{{translateServ.dictionary['total']}}:</strong> {{
												row.total_with_tax |
												number:'1.2-2' }}</div>
											<div><strong>{{translateServ.dictionary['tax']}}:</strong> {{ row.tax |
												number:'1.2-2'
												}}
												<span *ngIf="row.vat_in_precentages">({{ row.vat_in_precentages |
													number:'1.2-2'
													}}%)</span>
											</div>
										</td>


										<td style="padding: 0 4px;">
											<span [pTooltip]="row.CustomerSupplierExpenseCode" tooltipPosition="top"
												style="line-height: 1.1;">
												{{ row.CustomerSupplierExpenseCodeName }}<br />
												<span style="font-size: 0.95em; color: #666;">{{ row.Sug_tnua }}</span>
											</span>
										</td>
										<td class="actions-col">
											<button pButton type="button" icon="pi pi-eye"
												class="p-button-text p-button-sm"
												pTooltip="{{ translateServ.dictionary['VIEW_N_EDIT']}}"
												tooltipPosition="top" (click)="openPreview(row.FileRecID)"></button>
										<button *ngIf="classMode === 0" pButton type="button"
											[icon]="bulkMoveModeActive && bulkMoveFileRecIds.includes(row.FileRecID) ? 'pi pi-check-circle' : 'pi pi-truck'"
											class="p-button-text p-button-sm"
											pTooltip="{{ bulkMoveModeActive ? (translateServ.dictionary['SELECT_FILES_TO_MOVE'] || 'Mark for move') : translateServ.dictionary['STEP_TAB_TIT_CATEGORY']}}"
											tooltipPosition="top"
											(click)="onRowTruckClick(row, classificationPanel, $event)"></button>
											<p-overlayPanel #classificationPanel [appendTo]="'body'">
												<div class="flex flex-column gap-2" style="min-width: 12rem;">
													<button *ngFor="let option of getReassignClassificationOptions()"
														pButton type="button"
														class="p-button-text p-button-sm justify-content-start"
														(click)="reassignFileClassification(option, row, classificationPanel)">
														<span class="flex align-items-center gap-2">
															<i *ngIf="option.IconGrade"
																[class]="option.IconGrade || ''"></i>
															<span>{{ option.FileGradeClassification }}</span>
														</span>
													</button>
												</div>
											</p-overlayPanel>
											<button *ngIf="classMode === 0" pButton type="button"
												[icon]="workbenchFileRecIds.includes(row.FileRecID) ? 'pi pi-box' : 'pi pi-reply'"
												class="p-button-text p-button-sm"
												[pTooltip]="workbenchFileRecIds.includes(row.FileRecID) ? translateServ.dictionary['WORKBENCH_IN_MSG'] : translateServ.dictionary['WORKBENCH_ADD_MSG']"
												tooltipPosition="top" style="margin-left: 0.25rem;"
												(click)="addToWorkbench(row.FileRecID)"></button>
										</td>
									</tr>
									<tr *ngIf="row.expanded">
										<td colspan="11" class="app-expanded-table-cell bg-gray-50 p-3"
											style="max-width:0; width:100%; padding:0; overflow:hidden;">
											<p-tabView>
												<p-tabPanel
													header="{{ translateServ.dictionary['JOURNAL_MOVES_TITLE']}}">
													<div class="col-12 w-full p-0">
														<div class="sakai-table-container">
															<div class="inner-table-scroll-container">
																<app-watch #watchRef [SpecificFileRecID]="row.FileRecID"
																	[parentComp]="this"
																	(djwsChanged)="onDJWSChanged(true)"></app-watch>
															</div>
														</div>
													</div>
												</p-tabPanel>
												<p-tabPanel header="{{ translateServ.dictionary['FILE_GRADE']}}">
													<div class="grades-information-container">
														<ng-container
															*ngIf="fileGradesLoading[row.FileRecID]; else gradesInformationContent">
															<p-progressBar mode="indeterminate"
																[style]="{ height: '6px' }"></p-progressBar>
														</ng-container>

														<ng-template #gradesInformationContent>
															<div class="grades-chart-panel flex flex-col items-center">
																<div class="font-semibold text-xl mb-4">{{
																	translateServ.dictionary['GRADE_PER_GROUP']}}</div>
																<p-chart
																	*ngIf="fileGroupGrades[row.FileRecID]?.length; else noGroupGrades"
																	type="polarArea"
																	[data]="fileGradePolarAreaData[row.FileRecID]"
																	[options]="fileGradePolarAreaOptions"
																	styleClass="grade-category-chart"
																	[style]="{'display': 'block', 'width': '100%', 'max-width': '34rem', 'height': '420px'}"></p-chart>
																<ng-template #noGroupGrades>
																	<div class="text-600 p-3">{{
																		translateServ.dictionary['NO_DATA'] }}</div>
																</ng-template>
															</div>

															<div class="grades-features-panel">
																<p-table
																	[value]="fileFeatureGrades[row.FileRecID] || []"
																	[responsiveLayout]="'scroll'" [scrollable]="true"
																	scrollHeight="420px"
																	[tableStyle]="{'width': '100%'}"
																	styleClass="app-data-table app-data-table--compact app-data-table--fixed grades-feature-table">
																	<ng-template pTemplate="header">
									<tr>
										<th>{{ translateServ.dictionary['JMT_COL_ID']}}</th>
										<th>{{ translateServ.dictionary['PREV_JMD_HEADER_FEATURE']}}</th>
										<th>{{ translateServ.dictionary['GRADE']}}</th>
										<th class="feature-description-cell">{{
											translateServ.dictionary['MAINT_IN_TIT_DESC']}}</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-feature>
									<tr>
										<td>{{ feature.FileFeatureRecID }}</td>
										<td>
											<span class="feature-type-chip"
												[class.has-group-color]="feature.ChartColorNotification"
												[style.--feature-grade-color]="feature.ChartColorNotification">
												{{ feature.FeatureTranslation }}
											</span>
										</td>
										<td class="feature-grade-cell">
											<p-tag
												[value]="feature.FeatureErrorType ? feature.Grade + ' - ' + feature.FeatureErrorType : feature.Grade"
												[severity]="getBadgeSeverity(feature.ColorNotification)"></p-tag>
										</td>
										<td class="feature-description-cell">{{ feature.content_str }}</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="4" class="text-center p-4">{{ translateServ.dictionary['NO_DATA']
											}}</td>
									</tr>
								</ng-template>
							</p-table>
						</div>
						</ng-template>
		</div>
		</p-tabPanel>
		<p-tabPanel header="{{ translateServ.dictionary['INDEX_ACT_TAB_INFO']}}">
			<div class="flex flex-column gap-3">
				<!-- Only Math Totals Displayed -->
				<div class="surface-card shadow-2 border-round p-3" style="min-width:260px;max-width:340px;">
					<table class="w-full" style="border-collapse:collapse;">
						<tbody>
							<tr>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									&nbsp;</td>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									{{
									translateServ.dictionary['total_without_tax']}}</td>
								<td class="font-semibold text-primary text-right"
									style="min-width:90px; padding:2px 0;">{{
									row.total_without_tax | number:'1.2-2' }}</td>
							</tr>
							<tr>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									-
								</td>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									{{
									translateServ.dictionary['total_discount']}}</td>
								<td class="font-semibold text-primary text-right"
									style="min-width:90px; padding:2px 0;">{{
									row.total_discount | number:'1.2-2' }}</td>
							</tr>
							<tr>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									=
								</td>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									{{
									translateServ.dictionary['total_after_discount']}}</td>
								<td class="font-semibold text-primary text-right"
									style="min-width:90px; padding:2px 0;">{{
									row.total_after_discount | number:'1.2-2' }}</td>
							</tr>
							<tr>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									+
								</td>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									{{
									translateServ.dictionary['tax']}} <span class="text-400 text-xxs">({{
										row.vat_in_precentages
										}}%)</span></td>
								<td class="font-semibold text-primary text-right"
									style="min-width:90px; padding:2px 0;">{{
									row.tax | number:'1.2-2' }}</td>
							</tr>
							<tr>
								<td colspan="3">
									<hr class="my-1" style="border-top: 1.5px solid #bbb; margin:4px 0 2px 0;" />
								</td>
							</tr>
							<tr>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									=
								</td>
								<td class="text-600 text-xs" style="padding:2px 8px 2px 0;">
									{{
									translateServ.dictionary['total_with_tax']}}</td>
								<td class="font-semibold text-primary text-right"
									style="min-width:90px; padding:2px 0;">{{
									row.total_with_tax | number:'1.2-2' }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Financials Card: Only Total Displayed -->
				<div class="surface-card shadow-2 border-round p-3 flex flex-row justify-content-between align-items-center"
					style="min-width:220px;max-width:320px;">
					<span class="text-600 text-xs">{{
						translateServ.dictionary['total_with_tax']}}</span>
					<span class="font-semibold text-primary text-right" style="min-width:90px;">{{ row.total_with_tax
						}}</span>
				</div>
			</div>
		</p-tabPanel>
		</p-tabView>
		</td>
		</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td [attr.colspan]="11" class="text-center p-4">{{translateServ.dictionary['NO_DATA']}}</td>
			</tr>
		</ng-template>
		</p-table>
</div>
</ng-container>
</p-tabPanel>
</p-tabView>
</div>
</ng-container>
<!-- Notification Dialog for DocApprovalComponent (move outside table for correct DOM structure) -->
<app-notification-dialog [fileRecId]="currentFileRecIdForNotification" [(visible)]="displayNotificationsDialog"
	[isAllowedToChange]="classMode === 0" (notificationSummaryChange)="onNotificationSummaryChange($event)">
</app-notification-dialog>

<!-- Workbench Merge Dialog as a separate component -->
<app-merge-dialog [(visible)]="displayWorkbenchDialog" [mergeList]="workbenchList"
	(remove)="removeFromWorkbench($event)" (merge)="mergeWorkbench()"
	(visibleChange)="onMergeDialogVisibleChange($event)" (dialogClosed)="onMergeDialogClosed($event)">
</app-merge-dialog>

<!-- Lists files that have no real journal and therefore can never be sent to movein -->
<p-dialog header="{{ translateServ.dictionary['ORPHAN_FILE_TITLE']}}"
	[(visible)]="displayJournalLessDialog" [modal]="true" [dismissableMask]="true" [style]="{width: '40rem'}">
	<p-table [value]="journalLessDocuments" [responsiveLayout]="'scroll'"
		styleClass="app-data-table app-data-table--compact">
		<ng-template pTemplate="header">
			<tr>
				<th>{{ translateServ.dictionary['JMT_COL_ID'] }}</th>
				<th>{{ translateServ.dictionary['JMT_COL_ORIG_FILE_NAME'] }}</th>
				<th>{{ translateServ.dictionary['MAINT_CS_TIT_DATE_ENTERED'] }}</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-row>
			<tr>
				<td>{{ row.FileRecID }}</td>
				<td>{{ row.OriginalFileName }}</td>
				<td>{{ row.DateEntered }}</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="3" class="text-center p-3">{{ translateServ.dictionary['NO_DATA'] }}</td>
			</tr>
		</ng-template>
	</p-table>
</p-dialog>